import { getApiBaseUrl } from "./env";
import { ApiHttpError } from "./errors";
import { getAuthToken } from "./authToken";

function buildUrl(path: string): string {
  const base = getApiBaseUrl();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

async function parseBody(res: Response): Promise<unknown> {
  const text = await res.text();
  if (!text) return undefined;
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return text;
  }
}

/**
 * JSON request to the API. UI calls service functions that use this — not raw `fetch` in views.
 * Attaches Clerk Bearer token when available.
 */
export async function apiRequest<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const url = buildUrl(path);
  const token = await getAuthToken();
  const res = await fetch(url, {
    ...init,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });

  const body = await parseBody(res);

  if (!res.ok) {
    throw new ApiHttpError(res.status, body);
  }

  if (res.status === 204) {
    return undefined as T;
  }

  return body as T;
}
